<template>
    <div v-if="config != undefined" id="container-radio" class="h-full w-full max-md:pt-special">
        <Reproductor :texts="config['texts']" :caratula="config['caratula']"/>
    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';
import Reproductor from '../components/radio/Reproductor.vue'
import { generalStore } from '@/stores';

var config = ref({});

const store = generalStore();
const route = store.route;

store.setIsPP(false)

onBeforeMount(async () => {
    window.scrollTo(top);
    config.value = store.getSessionStorage('configuration-' + route.name);
    if (config.value == undefined || config.value == null) {
        config.value = await store.getConfiguration(route.name);
    }
})
</script>